  $(document).ready(function() {
    // HEADER SCRIPTS
    $('#site-header').hover(
      function() {
          $(this).css("background-color", "#f4f0f0");
          $('.menu__link__main').each(function(){
            if($(this).is('[data-handle]')) {
              if(!$(this).attr('data-handle').includes('sale')) {
                $(this).css("color", "#23443E");
              }
              console.log('here');
            } else {
              $(this).css("color", "#23443E");
            }
          });
          $('.menu__link__main a').css("color", "#23443E");
          $('.tala-logo-white').hide();
          $('.tala-logo-main').show();
          $('.has-dropdown-arrow').addClass('arrow-green');
          $('.has-dropdown-arrow').removeClass('arrow-white');
      }, function() {
        if($(window).scrollTop() < 750) {
          $(this).css("background-color", "transparent");
          $('.menu__link__main').each(function(){
            if($(this).is('[data-handle]')) {
              if(!$(this).attr('data-handle').includes('sale')) {
                $(this).css("color", "#ffffff");
              }
            } else {
              $(this).css("color", "#ffffff");
            }
          });
          $('.menu__link__main a').css("color", "#ffffff");
          $('.tala-logo-white').show();
          $('.tala-logo-main').hide();
          $('.has-dropdown-arrow').removeClass('arrow-green');
          $('.has-dropdown-arrow').addClass('arrow-white');
        }
      }
    );

    // $(".large-banner-container").on('scroll', function(){
    //     $('#site-header').css("background-color", "#f4f0f0");
    //     $('.menu__link__main').css("color", "#23443E");
    //     $('.menu__link__main a').css("color", "#23443E");
    //     $('.tala-logo-white').hide();
    //     $('.tala-logo-main').show();
    // });
    
    $(window).scroll(function(){
      if($(this).scrollTop() >= 750) {
        $('#site-header').css("background-color", "#f4f0f0");
        $('.menu__link__main').each(function(){
          if($(this).is('[data-handle]')) {
            if(!$(this).attr('data-handle').includes('sale')) {
              $(this).css("color", "#23443E");
            }
          } else {
              $(this).css("color", "#23443E");
          }
        });
        $('.menu__link__main a').css("color", "#23443E");
        $('.tala-logo-white').hide();
        $('.tala-logo-main').show();
        
        $('.has-dropdown-arrow').addClass('arrow-green');
        $('.has-dropdown-arrow').removeClass('arrow-white');
      } else {
        $('#site-header').css("background-color", "transparent");
        $('.menu__link__main').each(function(){
          if($(this).is('[data-handle]')) {
            if(!$(this).attr('data-handle').includes('sale')) {
              $(this).css("color", "#ffffff");
            }
          } else {
              $(this).css("color", "#ffffff");
          }
        });
        $('.menu__link__main a').css("color", "#ffffff");
        $('.tala-logo-white').show();
        $('.tala-logo-main').hide();

        $('.has-dropdown-arrow').removeClass('arrow-green');
        $('.has-dropdown-arrow').addClass('arrow-white');
      }
    });

    if($(this).scrollTop() >= 750) {
      $('#site-header').css("background-color", "#f4f0f0");
      $('.menu__link__main').each(function(){
          if($(this).is('[data-handle]')) {
            if(!$(this).attr('data-handle').includes('sale')) {
              $(this).css("color", "#23443E");
            }
          } else {
              $(this).css("color", "#23443E");
          }
      });
      $('.menu__link__main a').css("color", "#23443E");
      $('.tala-logo-white').hide();
      $('.tala-logo-main').show();
      
      $('.has-dropdown-arrow').addClass('arrow-green');
      $('.has-dropdown-arrow').removeClass('arrow-white');
    } else {
      $('#site-header').css("background-color", "transparent");
      $('.menu__link__main').each(function(){
          if($(this).is('[data-handle]')) {
            if(!$(this).attr('data-handle').includes('sale')) {
              $(this).css("color", "#ffffff");
            }
          } else {
              $(this).css("color", "#ffffff");
          }
      });
      $('.menu__link__main a').css("color", "#ffffff");
      $('.tala-logo-white').show();
      $('.tala-logo-main').hide();
      
      $('.has-dropdown-arrow').removeClass('arrow-green');
      $('.has-dropdown-arrow').addClass('arrow-white');
    }
    // HEADER SCRIPTS
  });